import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Location } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { ChargingStatusEnum, OcppStatusEnum } from '../pages/enums/charging-status.enum';
@Injectable({ providedIn: 'root' })

export class SharedService {
  Patterns = {
    Email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    MobileNumber: /^[1,2,3,4,5,6,7,8,9]{1}[0-9]{7,9}$/,///^\d{10}$/, 
    AlphabetsAndDigits: /^[a-zA-Z0-9]+$/,
    AlphabetsAndDigitsAndSpace: /^[a-zA-Z0-9 ]+$/,
    IND_MobileNumber: /^((\+91)?|91)?[789][0-9]{9}/,
    Password: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/,
    qatarMobilePattern: /^((\+974)|(974)|0)?[3-7]\d{7}$/,

    CivilId: /^(1|2|3)((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229)(\d{5})$/
  };
  arabicRegex = /^[\u0600-\u06FF 0-9.,;:'"!?()-]+$/;
  arabicRegexForSpaceNumeric = /^[\u0600-\u06FF 0-9 ]+$/;
  englishRegex = /^[a-zA-Z\s\d\\\/()#\_@!$%^&*+-=?!|؟]+$/;
  latRegex = /^-?([1-8]?\d(?:\.\d+)?|90(?:\.0+)?)$/;
  longRegex = /^-?(?:180(?:\.0+)?|(?:(?:1[0-7]\d)|(?:[1-9]?\d))(?:\.\d+)?)$/;
  emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  colorCorrespondsToStatus: any = {
    Available: 'green_clr',
    Inoperative: 'lightgray_clr',
    Occupied: 'yellow_clr',
    Offline: 'gray_clr',
    Reserved: 'blue_clr',
    Unavailable: 'red_clr'
  };
  clrCorrespondsToRequestStatus: any = {
    // below are status of requeststatus
    PendingApproval: 'orange_clr',
    Approved: 'darkgreen_clr',
    Rejected: 'darkred_clr'
  };
  OcppStatusCorrespondsChargingStatusEnum: any = {
    Offline: 0,
    Available: 1,
    Preparing: 2,
    Charging: 2,
    SuspendedEVSE: 2,
    SuspendedEV: 2,
    Finishing: 2,
    Unavailable: 3,
    Faulted: 3,
    Reserved: 4
  };
  loggedInUserName!: string;
  logo!: string;
  requestHeaders: HttpHeaders;
  matDialogConfig: MatDialogConfig = <MatDialogConfig>{ hasBackdrop: true, disableClose: true };
  constructor(private _http: HttpClient, private location: Location, private translate: TranslateService, private datePipe: DatePipe) {
    this.requestHeaders = new HttpHeaders;
  }

  /**
   * generic get service
   */
  GetLoggedInUserName() {
    return this.loggedInUserName;
  }

  GetLoggedInUserLogo() {
    return this.logo;
  }

  getRequiredValidationMessage(controlName: string) {
    return controlName + ' ' + this.translate.instant('common.is_required');
  }
  getEnglishOrArabicValidTitleMsg(controlName: string, isArabic: boolean = false) {
    return this.translate.instant('common.english_arabic_title', { title: controlName, lang: isArabic ? this.translate.instant('common.arabic') : this.translate.instant('common.english') })
  }
  getValidMessage(controlName: string) {
    return this.translate.instant('common.please_enter_valid') + ' ' + controlName;
  }

  getNotValidMessage(controlName: string, minValue: number, maxValue: number) {
    return this.translate.instant('common.should_be_between', { title: controlName, minvalue: minValue, maxvalue: maxValue })
  }
  getNotValidMessageForFixedNumber(controlName: string, value: number) {
    return this.translate.instant('common.should_be_number', { title: controlName, num: value })

  }
  convertIntoStandardDateFormat(value: string) {
    return value != "" && value ? this.datePipe.transform(value, 'yyyy-MM-dd') : null;
  }
  convertIntoTime(data :Date) {
      const formattedDate = this.datePipe.transform(data, 'shortTime');
      return formattedDate;
  }
  displayDateTimeInGrid(value: Date | string) {
    return value != "" && value ? this.datePipe.transform(value, 'dd/MM/yyyy') + ' ' + this.datePipe.transform(value, 'shortTime') : '--';
  }
  displayDateInGrid(value: Date | string) {
    return value != "" && value ? this.datePipe.transform(value, 'dd/MM/yyyy') : null;
  }
  setChargingStatusColor(chargingStatus: string) {
    return this.colorCorrespondsToStatus[chargingStatus];
  }
  setChargingStatusColorById(chargingStatusId: number | undefined) {
    return this.colorCorrespondsToStatus[ChargingStatusEnum[Number(chargingStatusId) ?? '']];
  }
  setChargingStatusColorByOcppStatusId(ocppStatusId: number | undefined) {
    return this.colorCorrespondsToStatus[ChargingStatusEnum[this.OcppStatusCorrespondsChargingStatusEnum[OcppStatusEnum[Number(ocppStatusId) ?? '']]]];
  }
  setRequestStatusColor(status: string | undefined,isToast : boolean = false) {
    return isToast ? 'toast_' + this.clrCorrespondsToRequestStatus[status ?? ''] : this.clrCorrespondsToRequestStatus[status ?? ''] ;
  }
  removeCharactersUntilFirstDigit(inputString: string) {
    var match = inputString.match(/\d/);
    if (match) {
      var index: any = match.index;
      return inputString.substring(index);
    }
    return inputString;
  }
  GetDefaultCurrencyFormat(price: any) {
    let currencyCode = sessionStorage.getItem('ISOCurrencyCode');
    if (currencyCode && (price != undefined || price != null)) {
      let amount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
      }).format(price);
      var amountM = amount.includes(currencyCode) ? amount.replace(currencyCode, '').trim() : amount;
      return this.removeCharactersUntilFirstDigit(amountM);
    }
    return null;
  }
  GetDefaultCurrencyFormatWithSymbol(price: any) {
    let currencyCode = sessionStorage.getItem('ISOCurrencyCode');
    if (currencyCode && (price != undefined || price != null)) {
      let amount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
      }).format(price);
      return amount.includes(currencyCode) ? amount.replace(currencyCode, '').trim() : amount;
    }
    return null;
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  allnumeric(evt: any) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  goBackToSearchPage() {
    this.location.back();
  }
  notAllowSpecialCharacters(event: any) {
    var regex = new RegExp(this.Patterns.AlphabetsAndDigits);
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  notAllowSpecialCharactersButAllowSpace(event: any) {
    var regex = new RegExp(this.Patterns.AlphabetsAndDigitsAndSpace);
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  notAllowSpecialCharactersInArabic(event: any) {
    var regex = new RegExp(this.arabicRegexForSpaceNumeric);
    //const regex = /^(?=.*?\p{Script_Extensions=Arabic})[\p{Script_Extensions=Arabic}]+$/u;

    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  onlyAllowFloatDigits(event: any, val: string) {
    var charC = (event.which) ? event.which : event.keyCode;
    if (charC == 46) {
      if (val.indexOf('.') === -1) {
        return true;
      } else {
        return false;
      }
    } else {
      if (charC > 31 && (charC < 48 || charC > 57))
        return false;
    }
    return true;
  }
    
  dateShortForm(date: Date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate();

    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];

    const year = date.getFullYear();

    return `${day}-${monthName}-${year}`;
  }
  formatDateTime12Hours(dateP: string | Date) {
    if (dateP) {
      let date = new Date(dateP);
      var hours = date.getHours();
      var minutes: any = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return this.dateShortForm(date) + ' ' + strTime;
    }
    return null;
  }
  notAllowedSpaces(e: any) {
    if (e.which == 32) {
      return false;
    }
    return true;
  }
}
